import { render } from "./MyStudentsRecodDataTable.vue?vue&type=template&id=262441c4&scoped=true"
import script from "./MyStudentsRecodDataTable.vue?vue&type=script&lang=js"
export * from "./MyStudentsRecodDataTable.vue?vue&type=script&lang=js"

import "./MyStudentsRecodDataTable.vue?vue&type=style&index=0&id=262441c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262441c4"]])

export default __exports__